import * as Yup from "yup";

//both 10 char minimum
//password === passwordrepeat
export const passwordResetValidationSchema = Yup.object().shape({
	password: Yup.string()
		.min(10, "Password needs to be 10 characters minumum")
		.required("Value required"),
	confirmPassword: Yup.string()
		.min(10, "Password needs to be 10 characters minumum")
		.oneOf([Yup.ref("password"), null], "Values do not match!")
		.required("Value required"),
	token: Yup.string().required("Value required"),
	memberId: Yup.string().required("Value required"),
});
